import AddButtonComponent from './AddButton/AddButton'
import FileComponent from './File/File'
import FilesPageContentComponent from './FilesPageContent/FilesPageContent'
import ModalAddBatchFileComponent from './ModalAddBatchFile/ModalAddBatchFile'
import SearchFiltersComponent from './SearchFilters/SearchFilters'

export const AddButton = AddButtonComponent
export const File = FileComponent
export const FilesPageContent = FilesPageContentComponent
export const ModalAddBatchFile = ModalAddBatchFileComponent
export const SearchFilters = SearchFiltersComponent
